import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 21px;
  height: 21px;
`

export const CalendarNotesIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V10.525H16.5V7.75H1.5V18.5H9.475V20H1.5ZM19.225 14.525L17.45 12.75L18.175 12.025C18.3135 11.8917 18.4898 11.825 18.7039 11.825C18.918 11.825 19.0917 11.8917 19.225 12.025L19.95 12.75C20.0833 12.8885 20.15 13.0648 20.15 13.2789C20.15 13.493 20.0833 13.6667 19.95 13.8L19.225 14.525ZM10.975 21V19.225L16.375 13.825L18.15 15.6L12.75 21H10.975ZM1.5 6.25H16.5V3H1.5V6.25Z" />
    </Svg>
  )
}
